var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFeedback(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9 9.61567C9.30453 9.34109 9.49603 8.94297 9.49603 8.5C9.49603 7.67157 8.82623 7 8 7C7.17377 7 6.50397 7.67157 6.50397 8.5C6.50397 8.94297 6.69547 9.34109 7 9.61567V16H6.5L2.96059 7.89443C2.6798 7.33137 2.6798 6.66863 2.96059 6.10557L3.97272 4.07594C4.32841 3.36266 4.57574 2.60005 4.7065 1.81343L5.00794 0H10.9921L11.2935 1.81343C11.4243 2.60005 11.6716 3.36266 12.0273 4.07594L13.0394 6.10557C13.3202 6.66863 13.3202 7.33137 13.0394 7.89443L9.5 16H9V9.61567Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFeedback);
export default __webpack_public_path__ + "static/media/feedback.bbd9b398a288a52fa01de58799d82da1.svg";
export { ForwardRef as ReactComponent };